import {
  StyledJobTitle,
  StyledName,
  StyledPhone,
} from "./UserDataV2.styles";

export const UserDataV2 = ({ ...props }) => {
  return (
    <span>
      <StyledName>{props.givenName + " " + props.surname}</StyledName>
      <StyledJobTitle>{props.jobTitle}</StyledJobTitle>
      <StyledPhone>{props.phone}</StyledPhone>
    </span>
  );
};
